import React from 'react';
import RecipeCard from './RecipeCard';
import { Hearts } from 'react-loader-spinner';

const SavedRecipes = ({ loading, favoriteRecipes, partnerFavorites, onViewRecipe, onRemoveRecipe }) => {
    const hasPartnerFavorites = partnerFavorites && partnerFavorites.length > 0;

    return (
        <div className="saved-recipes-container">
            {loading ? (
                <div className="recipes-loading">
                    <Hearts height="80" width="80" color="#f97316" ariaLabel="hearts-loading" visible={true} />
                    <h3>Loading your favorite recipes...</h3>
                </div>
            ) : (
                <>
                    <h2>Your Favorite Recipes</h2>
                    {favoriteRecipes && favoriteRecipes.length > 0 ? (
                        <div className="recipe-grid">
                            {favoriteRecipes.map(recipe => (
                                <RecipeCard
                                    key={recipe.id}
                                    recipe={recipe}
                                    onClick={() => onViewRecipe(recipe)}
                                    onDelete={() => onRemoveRecipe(recipe)}
                                    showRemoveButton={true}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="no-recipes">
                            <i className="pi pi-bookmark" style={{ fontSize: '3rem', color: '#ccc' }}></i>
                            <p>You haven't saved any recipes yet</p>
                        </div>
                    )}

                    {hasPartnerFavorites && (
                        <>
                            <h2 className="partner-section">Partner's Favorites</h2>
                            <div className="recipe-grid">
                                {partnerFavorites.map(recipe => (
                                    <RecipeCard
                                        key={`partner-${recipe.id}`}
                                        recipe={recipe}
                                        onClick={() => onViewRecipe(recipe)}
                                        showRemoveButton={false}
                                    />
                                ))}
                            </div>
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default SavedRecipes;
